import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";

const HMenuItemInner = ({ item, parentItem }) => {
  const itemCssClassWithBullet = (item, parentItem) => {
    if (item.bullet) {
      return `kt-menu__link-bullet--${item.bullet}`;
    }

    if (parentItem && parentItem.bullet) {
      return `kt-menu__link-bullet--${parentItem.bullet}`;
    }

    return "";
  };

  return (
    <>
      {/* if menu item has icon */}
      {item.icon && <i className={`kt-menu__link-icon ${item.icon}`} />}

      {/* if menu item using bullet */}
      {!item.icon && (item.bullet || (parentItem && parentItem.bullet)) && (
        <i
          className={`kt-menu__link-bullet ${itemCssClassWithBullet(
            item,
            parentItem
          )}`}
        >
          <span />
        </i>
      )}

      {!item.badge ? (
        <>
          <span className="" />
          {/* menu item title text */}
          <span className="text-sm font-medium">
            <FormattedMessage
              id={`TOPBAR.${item.title}`}
              defaultMessage="{title}"
              values={{ title: item.title }}
              className="font-medium text-sm"
            />
          </span>
        </>
      ) : (
        <>
          {/* menu item with badge */}
          <span className="kt-menu__link-text">
            {" "}
            <FormattedMessage
              id={`TOPBAR.${item.title}`}
              defaultMessage="{title}"
              values={{ title: item.title }}
            />
          </span>
          <span className="kt-menu__link-badge">
            <span
              className={`kt-badge kt-badge--brand kt-badge--inline kt-badge--pill ${item.badge.type} `}
            >
              {item.badge.value}
            </span>
          </span>
        </>
      )}
    </>
  );
};

export default injectIntl(HMenuItemInner);
